import React, { useState, useContext, useEffect } from "react";
import "../../css/CRUDModal.css";
import {apiList, baseAuthUrl, baseUrl} from "../../helpers/apiList";
import axios from "axios";
import { BankNameContext } from "../../context/BankNameContext";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import AuthorizationModal from "../authorizationModal/authorizationModal";
import { toast } from "react-toastify";
import confetti from "canvas-confetti";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import AddVectorIcon from "../../../src/assets/Icons/Add Vector.png";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";

const AddCourierMasterModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    ownerName: "",
    ownerMobileNo: "",
    ownerEmailId: "",
    address1: "",
    address2: "",
    address3: "",
    pinCode: "",
    country: "",
    companyName: "",
    area: "",
    retailerCode: "",
    retailerName: "",
  });

  const [errors, setErrors] = useState({
    ownerName: "",
    ownerMobileNo: "",
    ownerEmailId: "",
    address1: "",
    address2: "",
    address3: "",
    pinCode: "",
    country: "",
    companyName: "",
    area: "",
    retailerCode: "",
    retailerName: "",
  });
  const [showAuthModal, setShowAuthModal] = useState(false);

  const { loading, error } = useContext(BankNameContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (action === "add") {
      setFormData({
        ownerName: "",
        ownerMobileNo: "",
        ownerEmailId: "",
        address1: "",
        address2: "",
        address3: "",
        pinCode: "",
        country: "",
        companyName: "",
        area: "",
        retailerCode: "",
        retailerName: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      action === "check"
    ) {
      setFormData({
        ...editData,
        username: loggedInUserName,
        ownerName: columnData?.authPersonName,
        ownerMobileNo: columnData?.authPersonMobile,
        ownerEmailId: columnData?.authPersonEmail,
        address1: columnData?.address1,
        address2: columnData?.address2,
        address3: columnData?.address3,
        pinCode: columnData?.pincode,
        country: columnData?.country,
        companyName: columnData?.companyName,
        area: columnData?.area,
      });
    }
    setErrors({
      ownerName: "",
      ownerMobileNo: "",
      ownerEmailId: "",
      address1: "",
      address2: "",
      address3: "",
      pinCode: "",
      country: "",
      companyName: "",
      area: "",
      retailerCode: "",
      retailerName: "",
    });
  }, [show]);

  if (loading) {
    return <p>Loading data...</p>;
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "ownerEmailId") {
      updatedValue = value.toLowerCase();
    } else if (id === "ownerMobileNo") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));

    if (id === "pinCode") {
      validatePinCode(value);
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    // formData.companyName = formData.companyName.trim();
    // if (!formData.companyName) {
    //   newErrors.companyName = "Company Name is required";
    // } else if (
    //   !/^[A-Za-z0-9@&.,'\- ]+$/.test(formData.companyName) ||
    //   formData.companyName.length < 2 ||
    //   formData.companyName.length > 50
    // ) {
    //   newErrors.companyName =
    //     "Company name must be valid and between 2 and 50 characters";
    // } else if (/^(.)\1{2,}$/.test(formData.companyName)) {
    //   newErrors.companyName =
    //     "Company name cannot be made of a single repeated character";
    // }

    // Owner name validation (between 2 and 50 characters)
    // formData.ownerName = formData.ownerName.trim();

    // Retailer Code validation
    if (!formData.retailerCode) {
      newErrors.retailerCode = "Retailer code is required";
    } else if (
      !/^[A-Za-z0-9]+$/.test(formData.retailerCode) ||
      formData.retailerCode.length < 2 ||
      formData.retailerCode.length > 20
    ) {
      newErrors.retailerCode =
        "Retailer code must be 2-20 characters and contain only letters and numbers";
    } else if (/^([A-Za-z0-9])\1+$/.test(formData.retailerCode)) {
      newErrors.retailerCode =
        "Retailer code cannot consist of the same character repeated";
    }

    // Retailer Name validation
    if (!formData.retailerName) {
      newErrors.retailerName = "Retailer name is required";
    } else if (
      !/^[A-Za-z .-]+$/.test(formData.retailerName) ||
      formData.retailerName.length < 2 ||
      formData.retailerName.length > 50
    ) {
      newErrors.retailerName =
        "Retailer name must be 2-50 characters and contain only letters, spaces, dots, or hyphens";
    } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(formData.retailerName)) {
      newErrors.retailerName =
        "Retailer name cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(formData.retailerName.replace(/[ .-]/g, ""))
    ) {
      newErrors.retailerName =
        "Retailer name cannot consist of the same letter repeated";
    }
    if (!formData.ownerName) {
      newErrors.ownerName = "Owner name is required";
    } else if (
      !/^[A-Za-z@&.,'\- ]+$/.test(formData.ownerName) ||
      formData.ownerName.length < 2 ||
      formData.ownerName.length > 50
    ) {
      newErrors.ownerName =
        "Owner name must be between 2 and 50 characters and contain only letters";
    } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(formData.ownerName)) {
      newErrors.ownerName =
        "Owner name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(formData.ownerName.replace(/[ .-]/g, ""))
    ) {
      newErrors.ownerName =
        "Owner name cannot consist of the same letter repeated";
    }

    // Owner person mobile number validation
    if (!formData.ownerMobileNo) {
      newErrors.ownerMobileNo = "Owner mobile number is required";
    } else if (!/^[789]\d{9}$/.test(formData.ownerMobileNo)) {
      newErrors.ownerMobileNo =
        "Mobile number must be 10 digits and start with 7, 8, or 9";
    } else if (/^(\d)\1{9}$/.test(formData.ownerMobileNo)) {
      newErrors.ownerMobileNo = "Mobile number cannot have all repeated digits";
    } else if (
      formData.ownerMobileNo === "1234567890" ||
      formData.ownerMobileNo === "9876543210"
    ) {
      newErrors.ownerMobileNo = "Mobile number cannot be a simple sequence";
    }

    // Email validation (required and valid email)
    if (!formData.ownerEmailId) {
      newErrors.ownerEmailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|co\.[a-zA-Z]{2})$/.test(
        formData.ownerEmailId
      ) ||
      /\.com\./.test(formData.ownerEmailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(formData.ownerEmailId)
    ) {
      newErrors.ownerEmailId =
        "Enter valid email ending with .com .co.xx or .in";
    }

    // Address validation
    // formData.address1 = formData.address1.trim();
    if (!formData.address1) {
      newErrors.address1 = "Address is required";
    } else if (formData.address1.length < 5 || formData.address1.length > 150) {
      newErrors.address1 = "Address1 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        formData.address1
      )
    ) {
      newErrors.address1 =
        "Address 1 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(formData.address1)) {
      newErrors.address1 = "Address 1 must contain at least one letter";
    }

    // Address 2 validation (required)
    // formData.address2 = formData.address2.trim();
    if (!formData.address2) {
      newErrors.address2 = "Address is required";
    } else if (formData.address2.length < 5 || formData.address2.length > 150) {
      newErrors.address2 = "Address2 must be between 5 and 50 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        formData.address2
      )
    ) {
      newErrors.address2 =
        "Address 2 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(formData.address2)) {
      newErrors.address2 = "Address 2 must contain at least one letter";
    }

    // Address 3 validation (optional)
    // formData.address3 = formData.address3.trim();
    if (formData.address3) {
      if (formData.address3.length < 5 || formData.address3.length > 150) {
        newErrors.address3 = "Address 3 must be between 5 and 150 characters";
      } else if (
        !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
          formData.address3
        )
      ) {
        newErrors.address3 =
          "Address 3 contains invalid characters or starts/ends with spaces";
      } else if (!/[A-Za-z]/.test(formData.address3)) {
        newErrors.address3 = "Address 3 must contain at least one letter";
      }
    }

    if (!formData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // Country validation
    // formData.country = formData.country.trim();
    if (!formData.country) {
      newErrors.country = "Country is required";
    } else if (formData.country.length < 2 || formData.country.length > 50) {
      newErrors.country = "Country must be between 2 and 50 characters";
    } else if (!/^[A-Za-z .-]+$/.test(formData.country)) {
      newErrors.country =
        "Country can contain only letters, spaces, dots, or hyphens";
    } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(formData.country)) {
      newErrors.country = "Country cannot start or end with space or symbols";
    } else if (/^([A-Za-z])\1+$/.test(formData.country.replace(/[ .-]/g, ""))) {
      newErrors.country = "Country cannot be the same letter repeated";
    }

    // Area validation
    if (!formData.area) {
      newErrors.area = "Area is required";
    } else if (formData.area.length < 2 || formData.area.length > 150) {
      newErrors.area = "Area must be between 2 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        formData.area
      )
    ) {
      newErrors.area =
        "Area contains invalid characters or starts/ends with spaces or symbols";
    } else if (!/[A-Za-z]/.test(formData.area)) {
      newErrors.area = "Area must contain at least one letter";
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value?.trim();

    switch (id) {
      // case "companyName":
      //   if (!trimmedValue) {
      //     fieldErrors.companyName = "Company Name is required";
      //   } else if (
      //     !/^[A-Za-z0-9@&.,'\- ]+$/.test(trimmedValue) ||
      //     trimmedValue.length < 2 ||
      //     trimmedValue.length > 50
      //   ) {
      //     fieldErrors.companyName =
      //       "Company name must be valid and between 2 and 50 characters";
      //   } else if (/^(.)\1{2,}$/.test(trimmedValue)) {
      //     fieldErrors.companyName =
      //       "Company name cannot be made of a single repeated character";
      //   } else {
      //     fieldErrors.companyName = ""; // ✅ Clear error if valid
      //   }
      //   break;

      case "retailerCode":
        if (!trimmedValue) {
          fieldErrors.retailerCode = "Retailer code is required";
        } else if (
          !/^[A-Za-z0-9]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 20
        ) {
          fieldErrors.retailerCode =
            "Retailer code must be 2-20 characters and contain only letters and numbers";
        } else if (/^([A-Za-z0-9])\1+$/.test(trimmedValue)) {
          fieldErrors.retailerCode =
            "Retailer code cannot consist of the same character repeated";
        }
        break;

      case "retailerName":
        if (!trimmedValue) {
          fieldErrors.retailerName = "Retailer name is required";
        } else if (
          !/^[A-Za-z .-]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.retailerName =
            "Retailer name must be 2-50 characters and contain only letters, spaces, dots, or hyphens";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.retailerName =
            "Retailer name cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.retailerName =
            "Retailer name cannot consist of the same letter repeated";
        }
        break;

      case "ownerName":
        if (!trimmedValue) {
          fieldErrors.ownerName = "Owner name is required";
        } else if (
          !/^[A-Za-z@&.,'\- ]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.ownerName =
            "Owner name must be between 2 and 50 characters and contain only letters";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.ownerName =
            "Owner name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.ownerName =
            "Owner name cannot consist of the same letter repeated";
        }
        break;

      case "ownerMobileNo":
        if (!trimmedValue) {
          fieldErrors.ownerMobileNo = "Owner mobile number is required";
        } else if (!/^[789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.ownerMobileNo =
            "Mobile number must be 10 digits and start with 7, 8, or 9";
        } else if (/^(\d)\1{9}$/.test(trimmedValue)) {
          fieldErrors.ownerMobileNo =
            "Mobile number cannot have all repeated digits";
        } else if (
          trimmedValue === "1234567890" ||
          trimmedValue === "9876543210"
        ) {
          fieldErrors.ownerMobileNo =
            "Mobile number cannot be a simple sequence";
        }
        break;

      case "ownerEmailId":
        if (!trimmedValue) {
          fieldErrors.ownerEmailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|co\.[a-zA-Z]{2})$/.test(
            trimmedValue
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.ownerEmailId =
            "Enter valid email ending with .com .co.xx or .in";
        } else {
          fieldErrors.ownerEmailId = "";
        }
        break;

      case "address1":
        if (!trimmedValue) {
          fieldErrors.address1 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address1 =
            "Address 1 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.address1 =
            "Address 1 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address1 = "Address 1 must contain at least one letter";
        } else {
          fieldErrors.address1 = "";
        }
        break;

      case "address2":
        if (!trimmedValue) {
          fieldErrors.address2 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address2 =
            "Address 2 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.address2 =
            "Address 2 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address2 = "Address 2 must contain at least one letter";
        } else {
          fieldErrors.address2 = "";
        }
        break;

      case "address3":
        if (trimmedValue) {
          if (trimmedValue.length < 5 || trimmedValue.length > 150) {
            fieldErrors.address3 =
              "Address 3 must be between 5 and 150 characters";
          } else if (
            !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
              trimmedValue
            )
          ) {
            fieldErrors.address3 =
              "Address 3 contains invalid characters or starts/ends with spaces";
          } else if (!/[A-Za-z]/.test(trimmedValue)) {
            fieldErrors.address3 = "Address 3 must contain at least one letter";
          } else {
            fieldErrors.address3 = "";
          }
        } else {
          fieldErrors.address3 = "";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        } else {
          fieldErrors.pinCode = "";
        }
        break;

      case "country":
        // Country validation
        // formData.country = formData.country.trim();
        if (!trimmedValue) {
          fieldErrors.country = "Country is required";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 50) {
          fieldErrors.country = "Country must be between 2 and 50 characters";
        } else if (!/^[A-Za-z .-]+$/.test(trimmedValue)) {
          fieldErrors.country =
            "Country can contain only letters, spaces, dots, or hyphens";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.country =
            "Country cannot start or end with space or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.country = "Country cannot be the same letter repeated";
        }
        break;

      case "area":
        if (!trimmedValue) {
          fieldErrors.area = "Area is required";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 150) {
          fieldErrors.area = "Area must be between 2 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.area =
            "Area contains invalid characters or starts/ends with spaces or symbols";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.area = "Area must contain at least one letter";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state, country } = pinCodeData;
            setFormData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
              country,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          console.error("Error fetching pincode data:", error);
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";
  const isCheckMode = action === "check";

  const isReadOnly = isViewMode || isDeleteMode || isAuthMode || isCheckMode;

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddCourierModal = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    // If there are no validation errors, proceed to next step
    if (Object.keys(validationErrors).length === 0) {
      // handleNext();
      let apiUrl = "";
      if (action === "add") {
        apiUrl = apiList.CREATE_COURIER_MASTER;
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_COURIER_MASTER;
      }

      const payload = {
        username: loggedInUserName,
        // companyName: formData?.companyName,
        retailerCode: formData?.retailerCode,
        retailerName: formData?.retailerName,
        authPersonName: formData?.ownerName,
        authPersonEmail: formData?.ownerEmailId,
        authPersonMobile: formData?.ownerMobileNo,
        address1: formData?.address1,
        address2: formData?.address2,
        address3: formData?.address3,
        pincode: formData?.pinCode,
        area: formData?.area,
        city: formData?.city,
        state: formData?.state,
        country: formData?.country,
        ...(action === "modify" && { id: columnData?.id }),
      };

      axiosPostApi(apiUrl, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            });
            callApi(1);
            handleClose();
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }

          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, Request again",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing Wallet request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the Wallet request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
          callApi(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const authCourierMasterRequest = async (action, remarks) => {
    let status;
    let actionText;

    // Map the action to the correct status code
    switch (action?.approvalStatus) {
      case "approve":
        status = "2";
        actionText = "authorized";
        break;
      case "check":
        status = "1";
        actionText = "blocked";
        break;
      case "delete":
        status = "3";
        actionText = "blocked";
        break;
      case "reject":
        status = "5";
        actionText = "rejected";
        break;
      default:
        status = "5";
        actionText = "rejected";
    }

    const requestBody = {
      username: loggedInUserName,
      id: columnData?.id,
      status:
        isAuthMode && action?.approvalStatus !== "reject"
          ? "1"
          : isDeleteMode
          ? "3"
          : status,
      ...(action !== "delete" && { adminRemark: action?.remark }),
    };

    try {
      const response = await axiosPostApi(
        apiList.AUTH_COURIER_MASTER_DATA,
        requestBody
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed && isAuthMode) {
            fetchDashboardData();
          } else {
            callApi(1);
          }
        });

        if (action === "approve") {
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
        }
        handleClose();
      } else {
        CustomAlert({
          title: `Failed to ${actionText} Retailer(Courier)`,
          text:
            response.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error(`Error ${actionText} customer`, error);
      toast.error(`Failed to ${actionText} customer.`);
    }
  };

  const handleAuth = () => {
    setShowAuthModal(true);
  };

  const handleCloseModal = () => {
    setShowAuthModal(false);
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[1086px] min-h-fit rounded-3xl p-6 bg-white border border-gray-200">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title font-medium text-lg">
                    Add Courier Company (Retailer)
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                {action !== "add" && (
                  <div className="flex mb-3 text-center text-[#495057] gap-6">
                    <h5>
                      <span className="font-semibold">Company Name:</span>{" "}
                      {formData?.companyName}
                    </h5>
                    <h5>
                      <span className="font-semibold">Company Code:</span>{" "}
                      {formData?.companyId}
                    </h5>
                  </div>
                )}
                <div className="modal-body space-y-4">
                  {/* Row 1 */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="form-group">
                      <label htmlFor="retailerCode">
                        Retailer Code<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Enter Retailer Code"
                        id="retailerCode"
                        value={formData.retailerCode}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        disabled={isReadOnly}
                      />
                      {!isReadOnly && errors.retailerCode && (
                        <span className="error text-red-500 text-sm">
                          {errors.retailerCode}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="retailerName">
                        Retailer Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Retailer Name"
                        id="retailerName"
                        value={formData.retailerName}
                        disabled={isReadOnly}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z .-]*$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.retailerName && (
                        <span className="error text-red-500 text-sm">
                          {errors.retailerName}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="ownerName">
                        Authorised Person Name
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Enter Name"
                        id="ownerName"
                        value={formData.ownerName}
                        disabled={isReadOnly}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z .-]*$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.ownerName && (
                        <span className="error text-red-500 text-sm">
                          {errors.ownerName}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Row 2 */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="form-group">
                      <label htmlFor="ownerEmailId">
                        Authorised Email Id
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Enter Email Id"
                        id="ownerEmailId"
                        value={formData.ownerEmailId}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        disabled={isReadOnly}
                      />
                      {!isReadOnly && errors.ownerEmailId && (
                        <span className="error text-red-500 text-sm">
                          {errors.ownerEmailId}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="ownerMobileNo">
                        Authorised Mobile No.
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Enter Mobile No."
                        id="ownerMobileNo"
                        value={formData.ownerMobileNo}
                        disabled={isReadOnly}
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.ownerMobileNo && (
                        <span className="error text-red-500 text-sm">
                          {errors.ownerMobileNo}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="address1">
                        Address 1<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Address 1"
                        id="address1"
                        value={formData.address1}
                        disabled={isReadOnly}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.address1 && (
                        <span className="error text-red-500 text-sm">
                          {errors.address1}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Row 3 */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="form-group">
                      <label htmlFor="address2">
                        Address 2<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Address 2"
                        id="address2"
                        value={formData.address2}
                        disabled={isReadOnly}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.address2 && (
                        <span className="error text-red-500 text-sm">
                          {errors.address2}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="address3">Address 3</label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Address 3"
                        id="address3"
                        value={formData.address3}
                        disabled={isReadOnly}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.address3 && (
                        <span className="error text-red-500 text-sm">
                          {errors.address3}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="pinCode">
                        Pin Code<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Pin Code"
                        id="pinCode"
                        value={formData.pinCode}
                        disabled={isReadOnly}
                        maxLength={6}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.pinCode && (
                        <span className="error text-red-500 text-sm">
                          {errors.pinCode}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Row 4 */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="form-group">
                      <label htmlFor="state">State</label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px] cursor-not-allowed"
                        id="state"
                        value={formData.state || "State"}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="city">City</label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px] cursor-not-allowed"
                        id="city"
                        value={formData.city || "City"}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="area">
                        Area<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Area"
                        id="area"
                        value={formData.area}
                        disabled={isReadOnly}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z .-]*$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.area && (
                        <span className="error text-red-500 text-sm">
                          {errors.area}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Row 5 */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="form-group">
                      <label htmlFor="country">
                        Country<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control w-full !border-[#DDDDDD] !rounded-[5px]"
                        placeholder="Country"
                        id="country"
                        value={formData.country}
                        disabled={isReadOnly}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z .-]*$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!isReadOnly && errors.country && (
                        <span className="error text-red-500 text-sm">
                          {errors.country}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center gap-4 pt-4 border-t-0">
                  <button
                    type="button"
                    className="btn btn-back w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  {!isReadOnly && (action === "add" || action === "modify") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleAddCourierModal}
                    >
                      {action === "modify" ? "Update" : "Submit"}
                    </button>
                  )}
                  {(action === "auth" || action === "check") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleAuth}
                      disabled={columnData?.authStatus === "APPROVED"}
                    >
                      Next
                    </button>
                  )}
                  {action === "delete" && (
                    <button
                      type="button"
                      className="btn btn-danger w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={() => authCourierMasterRequest(action)}
                    >
                      Reject
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <AuthorizationModal
        show={showAuthModal}
        handleClose={handleCloseModal}
        callApi={authCourierMasterRequest}
      />
    </>
  );
};

export default AddCourierMasterModal;
